import { z } from 'zod'
import { zId, zIsoDate, zJsonBlob } from '../common'

// A knowledge source feeding the RAG grounding (currently sitemap). `status`
// is an open string server-side — known values get a tone in the UI registry,
// unknown ones render verbatim. Detail responses add the chunk counters.
export const zKnowledgeSource = z.object({
  id: zId,
  siteId: zId,
  name: z.string(),
  sourceType: z.string(),
  status: z.string(),
  config: zJsonBlob.nullish().default(null),
  lastIngestedAt: zIsoDate.nullish().default(null),
  documentsCount: z.number().nullish().default(null),
  // Detail only:
  chunksCount: z.number().optional(),
  embeddedChunksCount: z.number().optional(),
})
export type KnowledgeSource = z.infer<typeof zKnowledgeSource>

// POST …/knowledge_sources/:id/ingest → 202 { knowledgeSource, enqueued }.
export const zIngestResponse = z.object({
  knowledgeSource: zKnowledgeSource,
  enqueued: z.boolean(),
})
export type IngestResponse = z.infer<typeof zIngestResponse>
